import CtaMiddle from './CtaMiddle'

export default CtaMiddle
